import { useCallback, useRef, useState, type ReactNode } from 'react';

import { ToastContext, ToastResetContext, type ToastMessage } from '@/shared/hooks/useToast';

import { ToastRegion, type ToastItem } from './Toast';

/** One polite host for all portals. Waiting messages start their timer when visible. */
export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<ToastItem[]>([]);
  const sequence = useRef(0);
  const notify = useCallback((message: ToastMessage) => {
    const id = `toast-${++sequence.current}`;
    setToasts((current) => [...current, { ...message, id }]);
  }, []);
  const dismiss = useCallback((id: string) => {
    setToasts((current) => current.filter((toast) => toast.id !== id));
  }, []);
  // OBS-007 — the sign-in screen, and another identity's workspace, start with no message.
  const reset = useCallback(() => setToasts([]), []);

  return (
    <ToastContext.Provider value={notify}>
      <ToastResetContext.Provider value={reset}>
        {children}
        <ToastRegion toasts={toasts} onDismiss={dismiss} />
      </ToastResetContext.Provider>
    </ToastContext.Provider>
  );
}
